import Drupal from 'Drupal';
import $ from 'jquery';
import Slider from 'js/components/Slider';
import { sliderConfigs } from 'js/utils/settings';

Drupal.behaviors.testimonials = {
  attach: (context) => {
    context
      .querySelectorAll('.paragraph--testimonials .slider')
      .forEach((element) => {
        if (!element.Slider) {
          element.Slider = new Slider(element, sliderConfigs.testimonials);

          // SETTING CURRENT SLIDE IMAGE
          var loadCurrent =
            parseInt(
              element.Slider.slider
                .find('.slick-current')
                .attr('data-slick-index'),
            ) + 1;
          var sliderPTonLoad = element.Slider.slider.closest(
            '.paragraph--testimonials__container',
          );

          sliderPTonLoad
            .find(
              '.paragraph--testimonials__image .field--name-field-image-testimonial',
            )
            .addClass('vanish');
          sliderPTonLoad
            .find(
              '.paragraph--testimonials__image .field--name-field-image-testimonial:nth-child(' +
                loadCurrent +
                ')',
            )
            .removeClass('vanish')
            .fadeIn();
          sliderPTonLoad
            .find(
              '.paragraph--testimonials__image .field--name-field-image-testimonial.vanish',
            )
            .fadeOut();

          // ON CHANGE EVENT , UPDATE IMAGE TO THE RIGHT
          element.Slider.slider.on('afterChange', function () {
            var currentSlide =
              parseInt(
                $(this).find('.slick-current').attr('data-slick-index'),
              ) + 1;
            var sliderPT = $(this).closest(
              '.paragraph--testimonials__container',
            );

            sliderPT
              .find(
                '.paragraph--testimonials__image .field--name-field-image-testimonial',
              )
              .addClass('vanish');
            sliderPT
              .find(
                '.paragraph--testimonials__image .field--name-field-image-testimonial:nth-child(' +
                  currentSlide +
                  ')',
              )
              .removeClass('vanish')
              .fadeIn();
            sliderPT
              .find(
                '.paragraph--testimonials__image .field--name-field-image-testimonial.vanish',
              )
              .fadeOut();
          });
        }
      });
  },
};
